import { ContractViewModel } from '@ail/contracts-api'
import Box from '../Box/Box'
import { StatusCell } from '../Grid/Cells/StatusCell/StatusCell'
import { NumberPlate } from '../NumberPlate/NumberPlate'
import { printDate } from '../../../helpers/Utils'
import './ContractCard.scss'
import { Environment } from '../../../environment'
interface Props {
  contract?: ContractViewModel
  costCenter?: string
  companyName?: string
}
export default function ContractCard({ contract, costCenter, companyName }: Props) {
  return (
    <Box
      icon={'icon-contract'}
      title={'Contract’s details'}
      color={'violet'}
      content={
        <div className="contractCard">
          <div>
            <i className="icon-car-big" />
            <strong>{contract?.vehicle?.description}</strong>
          </div>
          <div className="flex between">
            <div>
              <div className="flex">
                <i className="icon-customers" /> <strong>{companyName}</strong>
              </div>
              <div className="flex">
                <i className="icon-driver" /> <strong>{contract?.vehicle?.driver?.displayName}</strong>
              </div>
            </div>
            <span className="flex">
              <i className="icon-units" /> <strong>{costCenter}</strong>
            </span>
          </div>
          <div className="flex between">
            <div>
              <div>
                {printDate(contract?.startDate)} - {printDate(contract?.endDate)}
              </div>
              <div>{contract?.vehicle?.chassisNumber}</div>
            </div>
            <div className="flex">
              <a
                target="_blank"
                rel="noreferrer"
                href={contract?.id ? `${Environment.WebAppUrl}/generalContracts/details/${contract?.id}` : undefined}
              >
                <i className="icon-4u" /> {contract?.reference}
              </a>
            </div>
          </div>
        </div>
      }
      titleContent={
        <>
          {NumberPlate({
            licenseNumber: contract?.vehicle?.licensePlate?.licenseNumber,
            country: contract?.vehicle?.licensePlate?.country,
          })}
          {contract?.state && <StatusCell status={contract.state}>{contract.state}</StatusCell>}
        </>
      }
    />
  )
}
